import { render, staticRenderFns } from "./CompanyCrudData.vue?vue&type=template&id=56cc4fa0&scoped=true"
import script from "./CompanyCrudData.vue?vue&type=script&lang=js"
export * from "./CompanyCrudData.vue?vue&type=script&lang=js"
import style0 from "./CompanyCrudData.vue?vue&type=style&index=0&id=56cc4fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cc4fa0",
  null
  
)

export default component.exports